'use client'

import { ResolvedAvatarImage } from '@/components/common/resolved-media-image'
import { Card, CardContent } from '@/components/ui/card'

import { useAuth } from '@/contexts/auth-context'

import { Avatar, AvatarFallback } from '../ui/avatar'

interface PostInputPreviewProps {
  onOpenEditor: () => void
}

export default function PostInputPreview({ onOpenEditor }: PostInputPreviewProps) {
  const { user } = useAuth()

  return (
    <Card className="w-full mx-auto bg-white shadow-sm border border-gray-200 rounded-lg">
      <CardContent className="p-4">
        {/* Input Preview Section */}
        <div className="flex items-center gap-3 mb-3">
          <Avatar className="h-10 w-10">
            <ResolvedAvatarImage avatar={user?.avatar} alt={`${user?.firstName} ${user?.lastName}`} />
            <AvatarFallback>
              {user?.firstName[0]}
              {user?.lastName[0]}
            </AvatarFallback>
          </Avatar>
          <button
            onClick={onOpenEditor}
            disabled={!user}
            className="flex-1 text-left px-4 py-3 bg-gray-100 hover:bg-gray-200 rounded-full text-gray-600 transition-colors duration-200"
          >
            {user && (
              <span>
                {user?.firstName || ''} {user?.lastName || ''} ơi,
              </span>
            )}{' '}
            bạn đang nghĩ gì thế?
          </button>
        </div>

        {/* <div className="flex items-center justify-between pt-2 border-t border-gray-200">
          <Button
            variant="ghost"
            className="flex-1 flex items-center justify-center gap-2 py-3 hover:bg-gray-100 rounded-lg transition-colors duration-200"
            onClick={onOpenEditor}
            disabled={!user}
          >
            <ImageIcon className="h-5 w-5 text-green-500" />
            <span className="text-gray-600 font-medium">Ảnh</span>
          </Button>

          <Button
            variant="ghost"
            className="flex-1 flex items-center justify-center gap-2 py-3 hover:bg-gray-100 rounded-lg transition-colors duration-200"
            onClick={onOpenEditor}
            disabled={!user}
          >
            <Smile className="h-5 w-5 text-yellow-500" />
            <span className="text-gray-600 font-medium">Cảm xúc/hoạt động</span>
          </Button>
        </div> */}
      </CardContent>
    </Card>
  )
}
